import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CustomNavbar = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <Navbar expand="lg" className="navbar-custom shadow-sm">
      <Container>
        <Navbar.Brand href="/bandleader" className="d-flex align-items-center animate__animated animate__fadeIn">
          <img
            src="/logo.png"
            alt="Karaoke Logo"
            style={{ maxWidth: '50px', marginRight: '15px', transition: 'transform 0.3s ease' }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          />
          <span style={{ fontFamily: "'blowbrush', sans-serif", fontSize: '1.5rem', color: 'white', fontWeight: 500 }}>
            IT'S ALL KARAOKE MANAGER
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="/bandleader"
              className="text-light mx-2"
              style={{ fontFamily: "'Montserrat', sans-serif", transition: 'color 0.3s ease' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff6b6b')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
            >
              Live Show
            </Nav.Link>
            <Nav.Link
              href="/musicdatabase"
              className="text-light mx-2"
              style={{ fontFamily: "'Montserrat', sans-serif", transition: 'color 0.3s ease' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff6b6b')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
            >
              Music Database
            </Nav.Link>
            <Nav.Link
              href="/usermanagement"
              className="text-light mx-2"
              style={{ fontFamily: "'Montserrat', sans-serif", transition: 'color 0.3s ease' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff6b6b')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
            >
              User Management
            </Nav.Link>
            <Nav.Link
              href="/notifications"
              className="text-light mx-2"
              style={{ fontFamily: "'Montserrat', sans-serif", transition: 'color 0.3s ease' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff6b6b')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
            >
              Notification Settings
            </Nav.Link>
          </Nav>
          {token && (
            <Nav>
              <Button
                variant="outline-light"
                onClick={handleLogout}
                style={{ fontFamily: "'Montserrat', sans-serif", borderColor: '#ff6b6b', color: '#ff6b6b', transition: 'all 0.3s ease' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#ff6b6b';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#ff6b6b';
                }}
              >
                Logout
              </Button>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;